/**
 * Parqet API configuration from environment variables.
 * Used for OAuth and API base URLs (direct or via proxy).
 */

const DEFAULT_API_BASE = 'https://connect.parqet.com';
const DEFAULT_TOKEN_URL = 'https://connect.parqet.com/oauth2/token';

export interface ParqetConfig {
  clientId: string;
  redirectUri: string;
  apiBase: string;
  tokenUrl: string;
  isConfigured: boolean;
}

export function getParqetConfig(): ParqetConfig {
  const clientId = import.meta.env.VITE_PARQET_CLIENT_ID ?? '';
  const redirectUri = import.meta.env.VITE_PARQET_REDIRECT_URI ?? '';
  const apiBase = (import.meta.env.VITE_PARQET_API_BASE ?? DEFAULT_API_BASE).replace(/\/$/, '');
  const tokenUrl = import.meta.env.VITE_PARQET_TOKEN_URL ?? DEFAULT_TOKEN_URL;

  return {
    clientId,
    redirectUri,
    apiBase,
    tokenUrl,
    isConfigured: Boolean(clientId && redirectUri),
  };
}

export const PARQET_SCOPE = 'portfolio:read';
